/**
 * i18n Hilfsfunktionen für das managd-investor-portal
 */

/**
 * Hilfsfunktion, um TypeScript-Fehler bei i18n zu vermeiden
 * Wandelt einen i18n-Schlüssel in einen String um
 * 
 * @param t - Die Übersetzungsfunktion von react-i18next
 * @param key - Der Übersetzungsschlüssel
 * @returns Den übersetzten String
 */
export const tStr = (t: any, key: string): string => String(t(key));

/**
 * Hilfsfunktion für Übersetzungen mit Parametern wie {{version}}
 * 
 * @param t - Die Übersetzungsfunktion von react-i18next
 * @param key - Der Übersetzungsschlüssel
 * @param options - Die Parameter für die Übersetzung
 * @param defaultText - Der Standardtext falls die Übersetzung fehlt
 * @returns Den übersetzten String mit eingesetzten Parametern
 */
export const tParams = (
  t: any, 
  key: string, 
  options: Record<string, any>, 
  defaultText?: string
): string => {
  // defaultValue hinzufügen, falls nicht vorhanden und defaultText gegeben
  const finalOptions = defaultText 
    ? { ...options, defaultValue: defaultText }
    : options;
    
  return String(t(key, finalOptions));
}; 